var React = require('react');

function PhotosCta (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("g",{"transform":"rotate(20 2.993 30.35)","key":0},[React.createElement("rect",{"stroke":"currentColor","strokeWidth":"1.5","fill":"#2F6476","x":".75","y":".75","width":"14.25","height":"16.5","rx":"1.5","key":0}),React.createElement("rect",{"fill":"currentColor","y":"11.25","width":"15.75","height":"6.75","rx":"1.5","key":1})]),React.createElement("g",{"transform":"translate(0 6)","key":1},[React.createElement("rect",{"stroke":"currentColor","strokeWidth":"1.5","fill":"#2F6476","x":".75","y":".75","width":"14.25","height":"16.5","rx":"1.5","key":0}),React.createElement("rect",{"fill":"currentColor","y":"11.25","width":"15.75","height":"6.75","rx":"1.5","key":1})])]));
}

PhotosCta.defaultProps = {"width":"26px","height":"24px","viewBox":"0 0 26 24"};

module.exports = PhotosCta;

PhotosCta.default = PhotosCta;
